/**
 * Default dashboard sections that are switched off while the product decides
 * whether to keep them.
 *
 * CR-8235: "Suppliers Requiring Attention" (the four Worst Quality / Worst OTIF
 * / Worst OTD / Highest Arrears ranking cards) is hidden at the business's
 * request (Joshua Rainbow, 15-16 Oct 2026) until it is decided whether the
 * section is wanted, and its data issues are looked into if so. The data
 * mapping (useDashboardData -> supplierRankings) and the cards are kept, so
 * bringing the section back is this one flag. Its guided-tour step is gated
 * on the same flag, so the tour never points at a section that is not there.
 */
export const SHOW_SUPPLIERS_REQUIRING_ATTENTION = false
